<template>
  <ul class="ml-4 h-full hidden sm:inline-flex items-center font-medium">
    <li>
      <TheNuxtLink
        class="px-4 py-2 rounded-md transition hover:bg-neutral-200 dark:hover:bg-neutral-800"
        :to="href.library.status.reading"
        >{{ t("layouts.default.library") }}</TheNuxtLink
      >
    </li>
    <li>
      <TheNuxtLink
        class="px-4 py-2 rounded-md transition hover:bg-neutral-200 dark:hover:bg-neutral-800"
        :to="href.discover.index"
        >{{ "Discover" }}</TheNuxtLink
      >
    </li>
    <li>
      <TheNuxtLink
        class="px-4 py-2 rounded-md transition hover:bg-neutral-200 dark:hover:bg-neutral-800"
        :to="href.feed.index"
        >{{ t("layouts.default.feed") }}</TheNuxtLink
      >
    </li>
    <li>
      <FlyoutMenu
        :items="[
          {
            name: t('layouts.default.creators'),
            description: 'Build your fandom on NamiComi',
            icon: IconBulb,
            href: href.creators.index,
          },
          {
            name: t('layouts.default.news'),
            description: 'The latest on anime, manga and games',
            icon: IconNews,
            href: href.news.index,
          },
          {
            name: t('layouts.default.contest'),
            description: 'Monthly contests, big prizes',
            icon: IconTrophy,
            href: href.contest.overview.index,
          },
          {
            name: t('layouts.default.publish'),
            description: 'Unlock your potential with NamiComi',
            icon: IconUpload,
            href: href.publish.overview.index,
          },
          {
            name: t('layouts.default.makeMoney'),
            description: 'Earn money with NamiComi',
            icon: IconCurrencyDollar,
            href: href.publish.makemoney.index,
          },
        ]"
      >
        <template #opener>
          <div
            class="px-4 py-2 cursor-pointer flex gap-2 rounded-md transition hover:bg-neutral-200 dark:hover:bg-neutral-800"
          >
            <span>
              {{ $t("layouts.default.more") }}
            </span>
            <IconChevronDown />
          </div>
        </template>
      </FlyoutMenu>
    </li>
  </ul>
</template>

<script setup lang="ts">
import {
  IconBulb,
  IconChevronDown,
  IconCurrencyDollar,
  IconNews,
  IconTrophy,
  IconUpload,
} from "@tabler/icons-vue";

const href = useHref();

const { t } = useNuxtApp().$i18n.global;
</script>
